import React, { useState } from 'react';
import { Image as ImageIcon, Film } from 'lucide-react';
import { COLORS } from '../../utils/constants';

const C = COLORS;

/**
 * A creative rendered at a fixed box size.
 *
 * Falls back to a neutral placeholder when there is no file, or when the file
 * fails to load, so a missing upload never collapses the row it sits in. The
 * failure is tracked per-src, so paging to a different record retries instead
 * of staying stuck on the placeholder.
 */
export const Thumbnail = ({ src, alt = '', width = 60, height = 44, radius = 8, isVideo = false, style }) => {
  const [failedSrc, setFailedSrc] = useState(null);
  const box = { width, height, borderRadius: radius, flexShrink: 0, ...style };

  if (!src || failedSrc === src) {
    const icon = Math.max(12, Math.round(Math.min(width, height) / 2.5));
    return (
      <div title={src ? 'Image unavailable' : 'No image'}
        style={{ ...box, background: C.g100, border: `1px solid ${C.g200}`, boxSizing: 'border-box',
          display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.g400 }}>
        {isVideo ? <Film size={icon} /> : <ImageIcon size={icon} />}
      </div>
    );
  }

  if (isVideo) {
    return (
      <video src={src} muted playsInline preload="metadata" onError={() => setFailedSrc(src)}
        style={{ ...box, objectFit: 'cover', background: C.g900 }} />
    );
  }

  return (
    <img src={src} alt={alt} loading="lazy" onError={() => setFailedSrc(src)}
      style={{ ...box, objectFit: 'cover', background: C.g100 }} />
  );
};

export default Thumbnail;
